import { useLocation } from 'react-router';
import { useMemo } from 'react';
import { useAuth } from '@contexts/auth';

/**
 * Hook to determine if secure layout components (header, sidebar) should be shown.
 * Returns false for public/auth pages, onboarding, and when user is not authenticated.
 */
export function useSecureLayout() {
  const { loading, isAuthenticated } = useAuth();
  const location = useLocation();

  const shouldShow = useMemo(() => {
    if (loading || !isAuthenticated) return false;

    const path = location.pathname;

    // Only show on /app/* or /shopify/billing pages
    if (!path.startsWith('/app') && !path.startsWith('/shopify/billing')) {
      return false;
    }

    // Hide on onboarding and redirect pages
    if (path.includes('/app/onboarding') || path.includes('/app/redirect')) {
      return false;
    }

    return true;
  }, [loading, isAuthenticated, location.pathname]);

  return shouldShow;
}
